import { render, staticRenderFns } from "./Audience.vue?vue&type=template&id=4cb4a24f&scoped=true&lang=pug&"
import script from "./Audience.vue?vue&type=script&lang=js&"
export * from "./Audience.vue?vue&type=script&lang=js&"
import style0 from "./Audience.vue?vue&type=style&index=0&id=4cb4a24f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb4a24f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VForm})
